import { render, staticRenderFns } from "./roomTreeDiv.vue?vue&type=template&id=2bda6e0f&scoped=true"
import script from "./roomTreeDiv.vue?vue&type=script&lang=js"
export * from "./roomTreeDiv.vue?vue&type=script&lang=js"
import style0 from "./roomTreeDiv.vue?vue&type=style&index=0&id=2bda6e0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bda6e0f",
  null
  
)

export default component.exports